export default function CaseStudy() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="results" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Реальные кейсы: как <strong>тренинг по переговорам</strong> меняет бизнес
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Три истории компаний, которые прошли системное обучение и получили измеримые результаты.
          </p>
        </div>

        <div className="space-y-8">
          {/* Case 1 */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-ship-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900">Международная логистическая компания</h3>
                  <p className="text-gray-500 text-sm">B2B, комплексное сопровождение</p>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-6 mb-8">
                <div className="bg-teal-50 rounded-xl p-6 text-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">18–23%</div>
                  <p className="text-sm text-gray-600">рост конверсии переговоров в сделки месяц к месяцу</p>
                </div>
                <div className="bg-teal-50 rounded-xl p-6 text-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">+20%</div>
                  <p className="text-sm text-gray-600">в среднем за период сопровождения</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 mb-3">Что было сделано:</h4>
                <div className="space-y-2 text-sm text-gray-700">
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Аудит 120+ переговорных записей и 80+ коммерческих предложений</span></div>
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Разработана переговорная матрица: сценарии для каждого типа клиентов</span></div>
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>2-дневный интенсив по переговорам + 3 месяца сопровождения</span></div>
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Внедрена система разбора переговоров и обратной связи</span></div>
                </div>
              </div>
            </div>
          </div>

          {/* Case 2 */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900">Israel Assist</h3>
                  <p className="text-gray-500 text-sm">B2C, команда продаж и поддержки, переговоры по продлению</p>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-6 mb-8">
                <div className="bg-teal-50 rounded-xl p-6 text-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">64→84%</div>
                  <p className="text-sm text-gray-600">рост продлений договоров</p>
                </div>
                <div className="bg-teal-50 rounded-xl p-6 text-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">×9</div>
                  <p className="text-sm text-gray-600">рост длительных оплат (средний чек)</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 mb-3">Что было сделано:</h4>
                <div className="space-y-2 text-sm text-gray-700">
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Изменена модель переговоров о продлении: от цены к ценности</span></div>
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Разработаны скрипты переговоров для трёх сегментов клиентов</span></div>
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Проведён тренинг с переговорными поединками и разбором звонков</span></div>
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Внедрён еженедельный разбор сложных переговорных кейсов</span></div>
                </div>
              </div>
            </div>
          </div>

          {/* Case 3 */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-shopping-bag-3-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900">Компания по продаже товаров из Китая</h3>
                  <p className="text-gray-500 text-sm">B2C, отдел продаж, переговоры с клиентами</p>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-6 mb-8">
                <div className="bg-teal-50 rounded-xl p-6 text-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">+55%</div>
                  <p className="text-sm text-gray-600">рост конверсии</p>
                </div>
                <div className="bg-teal-50 rounded-xl p-6 text-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">+$116 000</div>
                  <p className="text-sm text-gray-600">рост валовой прибыли</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 mb-3">Что было сделано:</h4>
                <div className="space-y-2 text-sm text-gray-700">
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Аудит переговорных скриптов и записей разговоров с клиентами</span></div>
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Разработана новая переговорная стратегия: от цены к экспертизе</span></div>
                  <div className="flex items-start gap-2"><i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i><span>Проведён интенсив с отработкой возражений и защитой цены</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Хочу такой же результат
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}